import CouponIcon from '@/components/icon/CouponIcon';
import { CouponBookingItem } from '@/types/coupon';
import { COUPON_TYPE, PROMOTION_TYPE } from '@/types/enums';
import { CouponOneTimeResponse } from '@/types/http-payload/coupon';
import { formatToCurrency } from '@/utils/formatNumber';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
interface CouponItemProps {
    coupon: CouponBookingItem | CouponOneTimeResponse,
    isForever?: boolean
}

export default observer(function CouponItem({
    coupon,
    isForever = false
}: CouponItemProps) {
    // hook
    const { t } = useTranslation();

    return (
        <div className='flex gap-5 items-center'>
            <CouponIcon color={coupon.couponType === COUPON_TYPE.FOREVER_USE ? '#FFBF34' : '#ED4448'} />
            <div className='flex-1'>
                <div className='flex flex-col gap-1'>
                    <div className='font-medium'>
                        {t('field.coupon_code')}
                        {': '}
                        {coupon?.couponCode || '--'}
                    </div>
                    <div className='text-[0.8125rem]'>
                        {t('booking_bike.sentences.coupon_off', {
                            rate: coupon.promotionType === PROMOTION_TYPE.PERCENTAGE ? `${coupon.discountRate}%` : `¥${formatToCurrency(coupon.discountRate)}`
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
});
